// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/csv_upload_history_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { CsvUploadHistoryService } from "./csv_upload_history_service_pb";

/**
 * ListCsvUploadHistories は CSV アップロード履歴を投入日時降順で返す。
 * 期間フィルタ未指定ならデフォルトで全件表示する。
 *
 * @generated from rpc bffuser.v1.CsvUploadHistoryService.ListCsvUploadHistories
 */
export const listCsvUploadHistories = CsvUploadHistoryService.method.listCsvUploadHistories;
